import React from "react";

import { useTranslation, Trans } from "react-i18next";

import main from '../../img/Trading/main.png'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative h-[662px]">
            <img src={main} alt="" className="w-full h-full object-cover"/>
            <div className="max-w-[1280px] mx-[20px] xl:mx-auto">
                <div className="absolute top-[100px]">
                    <p className="text-white font-[500] text-[20px] xl:text-[40px] leading-[1.2]"><Trans>{t('trading.1')}</Trans></p>
                    <p className="text-white font-[500] text-[32px] xl:text-[64px] leading-[1.2]"><Trans>{t('trading.2')}</Trans></p>
                    <p className="text-[#FFFFFF] xl:max-w-[517px] mt-[20px] xl:mt-[40px] roboto text-[16px] xl:text-[20px]">{t('trading.3')}</p>
                    <p className="text-[#FFFFFFB2] xl:max-w-[517px] mt-[20px] roboto text-[16px] xl:text-[20px]">{t('trading.4')}</p>
                </div>
            </div>
        </div>
    );
}

export default Main;